import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CommunityLandingPage.css';

const CommunityLandingPage: React.FC = () => {
  const navigate = useNavigate();

  const handleEnterCommunity = () => {
    navigate('/app/community');
  };

  return (
    <div className="community-landing">
      <div className="community-landing__content">
        <div className="community-landing__hero">
          <h1>中医社区 · Herbal Circle</h1>
          <p>
            与全国中医爱好者共享节气养生、体质调护、临床心得与膳食灵感。关注你感兴趣的医者，与志同道合的朋友互动交流。
          </p>
          <button type="button" onClick={handleEnterCommunity}>
            进入社区
          </button>
        </div>
        <div className="community-landing__grid">
          <section>
            <h2>沉浸式时间线</h2>
            <p>关注喜爱的医者与话题，获取实时推送，亦可切换“关注”“最新”视图。</p>
          </section>
          <section>
            <h2>专业互动</h2>
            <p>支持长文 Markdown、图片视频、处方关联、引用转发与多层评论讨论。</p>
          </section>
          <section>
            <h2>智能推荐</h2>
            <p>结合体质档案与浏览习惯，推荐贴近你的节气要点、体质调护方案。</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CommunityLandingPage;
